module.exports = __webpack_public_path__ + "static/media/gt.814a95c2.svg";